import { render } from "./RefundConfirm.vue?vue&type=template&id=7f47c01e"
import script from "./RefundConfirm.vue?vue&type=script&lang=js"
export * from "./RefundConfirm.vue?vue&type=script&lang=js"

import "./RefundConfirm.vue?vue&type=style&index=0&id=7f47c01e&lang=css"
script.render = render

export default script